import React from 'react';
import PageHeaderComponent from '../PageHeaderNavigations/PageHeader';

function PageHeader() {
  return <PageHeaderComponent />;
}

export default PageHeader;
